import StandingsBase from "./StandingsBase";

export default function StandingsAm() {
    return (
        <StandingsBase
            scopeType="DRIVER"
            classKey="AM"
            heading="Meisterschaftswertung"
            pillLabel="AM"
        />
    );
}
